/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type AutoApproveQualityFlagType =
  (typeof AutoApproveQualityFlagType)[keyof typeof AutoApproveQualityFlagType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AutoApproveQualityFlagType = {
  StartPositionMissing: 1,
  EndPositionMissing: 2,
  GpsRejected: 3,
  EndPositionOutsideRadius: 4,
  FuelOverrun: 5,
  StartPositionOutsideRadius: 6,
  LocalTransitTicketInHomeCounty: 7,
} as const;
